// extracted by mini-css-extract-plugin
export default {"videoWrapper":"video-attachment_videoWrapper__87omf","video":"video-attachment_video__Yn3rn","videoOverlay":"video-attachment_videoOverlay__wKzwm"};